<div class="flex flex-col max-h-screen -m-6">
    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ dialogTitle }}</div>
        <button mat-icon-button (click)="onClose()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>

    <form class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto" [formGroup]="outwardChangeReqForm">
        <!--  Fees Amount -->
        <div class="flex items-center space-x-4">
            <mat-checkbox class="mb-4" (change)="onCheckedChange($event, 'feesAmount')"></mat-checkbox>
            <div class="w-32 mb-4">Fees Amount</div>
            <div class="w-20 text-right text-gray-500 mb-4">
                {{ data.outward.feeAmount }}
            </div>
            <mat-form-field appearance="outline">
                <mat-label>Fees Amount</mat-label>
                <input matInput type="number" formControlName="feesAmount" placeholder="Fees Amount"
                    [readonly]="!checkedStates.feesAmount" />
            </mat-form-field>
        </div>

        <!-- Visit Charge -->
        <div class="flex items-center space-x-4">
            <mat-checkbox class="mb-4" (change)="onCheckedChange($event, 'visitCharge')"></mat-checkbox>
            <div class="w-32 mb-4">Visit Charge</div>
            <div class="w-20 text-right text-gray-500 mb-4">
                {{ data.outward.visitCharge }}
            </div>
            <mat-form-field appearance="outline">
                <mat-label>Visit Charge</mat-label>
                <input matInput type="number" formControlName="visitCharge" placeholder="Visit Charge"
                    [readonly]="!checkedStates.visitCharge" />
            </mat-form-field>
        </div>

        <!-- Typing Charge -->
        <div class="flex items-center space-x-4">
            <mat-checkbox class="mb-4" (change)="onCheckedChange($event, 'typingCharge')"></mat-checkbox>
            <div class="w-32 mb-4">Typing Charge</div>
            <div class="w-20 text-right text-gray-500 mb-4">
                {{ data.outward.typingCharge }}
            </div>
            <mat-form-field appearance="outline">
                <mat-label>Typing Charge</mat-label>
                <input matInput type="number" formControlName="typingCharge" placeholder="Typing Charge"
                    [readonly]="!checkedStates.typingCharge" />
            </mat-form-field>
        </div>

        <!-- Remark -->
        <div class="flex items-start space-x-4">
            <mat-form-field class="flex-1" appearance="outline">
                <mat-label>Remarks</mat-label>
                <textarea matInput formControlName="remark" placeholder="Enter remarks" rows="3"></textarea>
                <mat-error *ngIf="outwardChangeReqForm.get('remark')?.hasError('required')">
                    Remarks is required
                </mat-error>
            </mat-form-field>
        </div>
        
        <!-- Footer -->
        <div class="flex justify-end space-x-2 p-4 border-t">
            <button mat-flat-button color="primary" (click)="save()" [disabled]="!saveButtonEnabled">
                Save
            </button>
        </div>
    </form>
</div>